module.exports = require("./es-EA.d.ts");